module.exports = __webpack_public_path__ + "static/media/construction-rehabilitation.faca9784.svg";